import { axiosInstance } from "../axios.config";

/** Epic 8 in-app pop-ups (stored server-side until answered) */
/** escrow_choice: PRD 9.1, answered through the escrow endpoints, not answer() */
export type AffiliatePromptKind = "title_prelim" | "lender_loan" | "agreement_relist" | "agreement_fee" | "escrow_choice";

export interface AffiliatePrompt {
  id: string;
  kind: AffiliatePromptKind;
  listingId: string;
  /** The accepted offer the pop-up is about */
  bidId?: string | null;
  listingAddress: string;
  affiliateName: string | null;
  feeAmount: number | null;
  createdAt: string;
}

export type PartnerKind = "title" | "hml" | "mortgage";

export interface PartnerView {
  email: string;
  name: string;
}

export interface PartnerGroup {
  partners: Record<PartnerKind, PartnerView | null>;
  /** FlipIQ's default group: applies to any slot left empty */
  defaults: Record<PartnerKind, PartnerView | null>;
}

export interface ClosingAlertsSetting {
  available: boolean;
  enabled: boolean;
}

export const affiliatesService = {
  async prompts(): Promise<AffiliatePrompt[]> {
    const res = await axiosInstance.get<AffiliatePrompt[]>("/affiliates/prompts");
    return res.data;
  },

  async answer(id: string, answer: "yes" | "no" | "seen"): Promise<{ status: string }> {
    const res = await axiosInstance.post<{ status: string }>(`/affiliates/prompts/${id}/answer`, { answer });
    return res.data;
  },

  async partners(): Promise<PartnerGroup> {
    const res = await axiosInstance.get<PartnerGroup>("/affiliates/partners");
    return res.data;
  },

  /** Empty string clears a slot */
  async setPartners(changes: Partial<Record<PartnerKind, string>>): Promise<PartnerGroup> {
    const res = await axiosInstance.put<PartnerGroup>("/affiliates/partners", changes);
    return res.data;
  },

  async closingAlerts(): Promise<ClosingAlertsSetting> {
    const res = await axiosInstance.get<ClosingAlertsSetting>("/affiliates/closing-alerts");
    return res.data;
  },

  async setClosingAlerts(enabled: boolean): Promise<{ enabled: boolean }> {
    const res = await axiosInstance.put<{ enabled: boolean }>("/affiliates/closing-alerts", { enabled });
    return res.data;
  },
};
